'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const VERSION = 'v1';

const storageKey = scopeKey => 'op-card-intro:' + VERSION + ':' + scopeKey;

function createIntro(React) {
  var _temp;

  const h = React.createElement;
  return _temp = class OpCardIntro extends React.Component {
    constructor(props) {
      super(props);

      _defineProperty(this, "close", () => {
        this.remember(this.props.scopeKey);
        this.release();
        this.setState({
          open: false
        });
      });

      _defineProperty(this, "replay", () => {
        this.setState({
          open: true,
          manual: true,
          muted: true,
          error: false
        }, () => this.lock());
      });

      _defineProperty(this, "play", async () => {
        const video = this.video,
              scope = this.props.scopeKey;
        if (!video || !this.alive || this.trying) return;
        this.trying = true;

        try {
          await video.play();
        } catch (_error) {
          if (this.alive && scope === this.props.scopeKey) this.setState({
            manual: true
          });
        } finally {
          this.trying = false;
        }
      });

      this.state = {
        open: false,
        manual: false,
        muted: true,
        error: false
      };
      this.alive = false;
      this.video = null;
      this.trying = false;
    }

    host() {
      return this.props.host || (typeof window === 'undefined' ? null : window);
    }

    componentDidMount() {
      this.alive = true;
      this.prepare();
    }

    componentDidUpdate(previous) {
      if (previous.scopeKey !== this.props.scopeKey) {
        this.release();
        this.prepare();
      }
    }

    componentWillUnmount() {
      this.alive = false;
      this.release();
    }

    prepare() {
      const host = this.host();
      if (!host || !this.props.scopeKey) return;
      let watched = false;

      try {
        watched = host.localStorage.getItem(storageKey(this.props.scopeKey)) === 'watched';
      } catch (_error) {}

      const reduced = !!(host.matchMedia && host.matchMedia('(prefers-reduced-motion: reduce)').matches);
      this.reduced = reduced;
      this.setState({
        open: !watched,
        manual: reduced,
        muted: true,
        error: false
      }, () => {
        if (!watched) this.lock();
      });
    }

    lock() {
      const host = this.host();
      if (!host || !host.document || this.locked) return;
      this.previousFocus = host.document.activeElement;
      this.overflow = host.document.body.style.overflow;
      host.document.body.style.overflow = 'hidden';
      this.locked = true;
      if (this.closeButton) this.closeButton.focus();
    }

    release() {
      if (this.video) {
        this.video.pause();
        this.video.currentTime = 0;
      }

      this.trying = false;
      const host = this.host();

      if (this.locked && host && host.document) {
        host.document.body.style.overflow = this.overflow;
        this.locked = false;
        if (this.previousFocus && this.previousFocus.focus) this.previousFocus.focus();
      }
    }

    remember(scope) {
      if (!this.alive || scope !== this.props.scopeKey) return;

      try {
        this.host().localStorage.setItem(storageKey(scope), 'watched');
      } catch (_error) {}
    }

    render() {
      const scope = this.props.scopeKey,
            base = this.props.mediaBase || '/op-card-art';
      return h(React.Fragment, null, h('button', {
        type: 'button',
        className: 'opcards-intro-replay',
        onClick: this.replay
      }, '查看揭卡介紹'), this.state.open && h('div', {
        className: 'opcards-intro-backdrop',
        role: 'dialog',
        'aria-modal': true,
        'aria-label': 'OP 卡包揭卡介紹',
        onKeyDown: event => {
          if (event.key === 'Escape') this.close();
        }
      }, h('section', {
        className: 'opcards-intro-modal'
      }, h('header', null, h('strong', null, '從邊緣慢慢揭開你的典藏'), h('button', {
        type: 'button',
        ref: el => {
          this.closeButton = el;
        },
        onClick: this.close
      }, '略過介紹')), h('video', {
        key: scope,
        ref: el => {
          this.video = el;
        },
        src: base + '/op-opening-intro-v1.mp4',
        poster: base + '/op-opening-intro-v1.jpg',
        muted: this.state.muted,
        playsInline: true,
        controls: true,
        preload: 'metadata',
        autoPlay: !this.state.manual,
        onCanPlay: () => {
          if (scope === this.props.scopeKey && !this.state.manual) this.play();
        },
        onPlaying: () => {
          this.remember(scope);
          if (this.alive && scope === this.props.scopeKey) this.setState({
            manual: false,
            error: false
          });
        },
        onError: () => {
          if (this.alive && scope === this.props.scopeKey) this.setState({
            error: true,
            manual: true
          });
        }
      }), h('p', null, '示範動畫 · 由任何邊緣慢慢揭開。此介紹不會開啟或派發你的卡包。'), this.state.error && h('p', {
        role: 'status'
      }, '影片暫時無法載入，可稍後重新播放或略過。'), h('div', {
        className: 'opcards-intro-actions'
      }, h('button', {
        type: 'button',
        onClick: this.play
      }, this.state.manual ? '播放介紹' : '重新播放／繼續'), h('button', {
        type: 'button',
        onClick: () => {
          if (this.video) this.video.muted = !this.state.muted;
          this.setState({
            muted: !this.state.muted
          });
        }
      }, this.state.muted ? '開啟聲音' : '靜音'), h('button', {
        type: 'button',
        onClick: this.close
      }, '開始查看卡包')))));
    }

  }, _temp;
}

module.exports = {
  VERSION,
  storageKey,
  createIntro
};
